module.exports = __webpack_public_path__ + "static/media/sige_screenshot.f3088d7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/sige_screenshot.png
// module id = 240
// module chunks = 0